import {
  Card,
  ChartEmptyState,
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { SpaceAccessControl } from '@eggplant/context'
import type { CSSProperties } from 'react'

const chartEmptyStateWrapper: CSSProperties = {
  display: 'grid',
  height: '78px'
}

const TestConfigNoTestStep = () =>
  <div className='grid'>
    <div style={chartEmptyStateWrapper}>
      <Card>
        <ChartEmptyState
          title='No steps added yet'
        >
          <SpaceAccessControl isHiddenIfDenied>
            <Paragraph>
              <Color variant='theme-filter-icon'>
                Please add step from the list on left.
              </Color>
            </Paragraph>
          </SpaceAccessControl>
        </ChartEmptyState>
      </Card>
    </div>
  </div>

export default TestConfigNoTestStep
